import React from 'react'
import { CompanyScreen } from '@src/components/screens/CompanyScreen'

export default (props: any) => <CompanyScreen locale="ja" {...props} />
